import React from "react";

import { Container, Row } from "reactstrap";

import Main from "../components/Main";

import "../assets/styles/Auth.scss";

const AuthLayout = ({ children }) => {
  return (
    <div className="auth">
      <Main className="d-flex justify-content-center align-items-center h-100">
        <Container className="d-flex flex-column">
          <Row>{children}</Row>
        </Container>
      </Main>
    </div>
  );
};

export default AuthLayout;
